/**
 * api-base.ts — Base URL rule for ɳSentry SaaS API calls
 *
 * Purpose:    One pure rule for where saas-client sends SaaS calls. A production
 *             build is always same-origin ('') so the vercel.json /v1 rewrite
 *             carries the call and the CSP connect-src (packages/csp, nsentry
 *             entry) holds; a VITE_API_URL baked from the Vercel production env
 *             must not send it cross-origin (D-0898).
 * Inputs:     { PROD, VITE_API_URL } from import.meta.env
 * Outputs:    Base URL string ('' means same-origin)
 * Constraints: Pure, no I/O. In a non-production build VITE_API_URL still
 *             overrides (dev proxy); without it dev hits the absolute origin.
 * SOT:        P7-PROD-85 / D-0898
 */

export const DEV_API_ORIGIN = 'https://api.sentry.nself.org'

export interface ApiBaseEnv {
  PROD?: boolean
  VITE_API_URL?: string
}

export function resolveApiBase(env: ApiBaseEnv): string {
  if (env.PROD) return ''
  return env.VITE_API_URL ?? DEV_API_ORIGIN
}
